"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultJSItemAnimator = void 0;
var DefaultWebItemAnimator_1 = require("../../../web/itemanimators/DefaultWebItemAnimator");
Object.defineProperty(exports, "DefaultJSItemAnimator", { enumerable: true, get: function () { return DefaultWebItemAnimator_1.DefaultWebItemAnimator; } });
//# sourceMappingURL=DefaultJSItemAnimator.web.js.map